export default __webpack_public_path__ + "static/media/R2D2.21c271e3.mp3";